if (!window.SeranovaTracking) {
  window.SeranovaTracking = (() => {
    const STORAGE_KEY = 'seranova:utm-params';
    const PARAM_PREFIX = 'cc_custom_';

    function getSourceParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const sourceParams = [];

      for (const [key, value] of urlParams.entries()) {
        if ((key.startsWith('tw_') || key.startsWith('utm_')) && value !== '') {
          sourceParams.push([key, value]);
        }
      }

      if (sourceParams.length) {
        saveSourceParams(sourceParams);
        return sourceParams;
      }

      return getStoredSourceParams();
    }

    function getStoredSourceParams() {
      try {
        const rawValue = window.sessionStorage.getItem(STORAGE_KEY);

        if (!rawValue) {
          return [];
        }

        const parsedValue = JSON.parse(rawValue);

        if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
          return [];
        }

        return Object.entries(parsedValue).filter(
          ([key, value]) => (key.startsWith('tw_') || key.startsWith('utm_')) && typeof value === 'string' && value,
        );
      } catch (error) {
        return [];
      }
    }

    function saveSourceParams(sourceParams) {
      try {
        const payload = {};
        sourceParams.forEach(([key, value]) => {
          payload[key] = value;
        });
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (error) {
        // Ignore storage failures.
      }
    }

    function appendParams(url) {
      if (!url) {
        return url;
      }

      const sourceParams = getSourceParams();

      if (!sourceParams.length) {
        return url;
      }

      let parsedUrl;

      try {
        parsedUrl = new URL(url, window.location.origin);
      } catch (error) {
        return url;
      }

      sourceParams.forEach(([key, value]) => {
        const trackingKey = `${PARAM_PREFIX}${key}`;

        if (!parsedUrl.searchParams.has(trackingKey)) {
          parsedUrl.searchParams.append(trackingKey, value);
        }
      });

      return parsedUrl.toString();
    }

    return {
      appendParams,
      getSourceParams,
    };
  })();
}
